import * as React from 'react'
import { NavLink } from 'react-router-dom'
import { Action, any, IOWidget, loadingAsyncState, Pair, wait } from 'widgets-for-react';
import { fromJSX, getRandomArbitrary, GroupArray } from '../../../../../utils';
import { CustomRouteParams } from '../../../../cms/router/type.gen';
import { emptyAppState, PublicSiteState } from '../../../../public_site.main.mod';
import { loader } from '../../../templates/loader.mod';
import { CustomPagesState, PublicSiteCustomRoutes } from '../../types.mod';
import { PageTemplateComponent } from '../../../../cms/page/widget.gen';
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen';
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.mod';
import { CustomBlockData } from '../../../blocks/custom_blocks/types.mod';
import { ExtraImages, getImageAttribute } from '../../../utils/extra_images.mod';
import { PublicSite_CustomPageData } from '../../../application.mod';
import { TemplateState } from '../../../../cms/page/types.gen';
import { page } from '../../../templates/page.mod';
import { WordPressBlockImagesLoader } from '../../../../wordpress/rendering/image_utils.mod';
import { WordPressBlock_To_WidgetBlock } from '../../../../wordpress/wordpress_to_cms.gen';
import { notfound_page } from '../../../templates/error_page.mod';
import { CustomBlock_To_Widget } from '../../../CustomBlockToWidget'
import { WordPress } from '../../../../wordpress/wordpress_api';
import { get_stories_overview } from '../Fc150Years.api';
import { List } from 'immutable';




export let themesCurrentScroll: number = 0;
export let themesAnimFrameId: number = null;

function themesRequestAnimationFrame() {
  // Exit and restart the scrollHandling if there was no difference in scroll
  if (window.scrollY == themesCurrentScroll) {
    handleThemesIcon('init'); // Init the icon once to show correct values on page load
    // handleThemesParallax('init'); // Init the parallax once to show correct values on page load
    themesAnimFrameId = requestAnimationFrame(themesRequestAnimationFrame);
    return;
  }

  // ----- STICKY ICON -----
  handleThemesIcon('runtime');
  // ----- end STICKY ICON -----

  // ----- PARALLAX (Themes overview) -----
  // handleThemesParallax('runtime');
  // ----- end PARALLAX (Themes overview) -----

  themesCurrentScroll = window.scrollY;
  themesAnimFrameId = requestAnimationFrame(themesRequestAnimationFrame); // Restart the scrollHandling
  return;
}

function handleThemesIcon(type: 'init' | 'runtime') {
  const textEl: HTMLElement = document.querySelector('.theme-intro__text');
  const iconEl: HTMLElement = document.querySelector('.theme-intro__icon');

  if ((
    (textEl == null || iconEl == null) ||
    (type == 'init' && iconEl != null && iconEl.classList.contains('init'))
  )) {
    return;
  }

  if ((iconEl.getBoundingClientRect().top + (iconEl.getBoundingClientRect().height / 2)) < (window.innerHeight / 2)) {
    iconEl.classList.add('sticky');
  }

  if (iconEl.getBoundingClientRect().bottom <= textEl.getBoundingClientRect().bottom) {
    iconEl.classList.remove('sticky');
  }

  if (!iconEl.classList.contains('init')) {
    iconEl.classList.add('init');
  }
}

// function handleThemesParallax(type: 'init' | 'runtime') {
//   if (enableReducedMotion == true) { return; }

//   const storiesContainer: HTMLElement = document.querySelector('.theme-stories__wrap');
//   const stories: NodeListOf<HTMLElement> = document.querySelectorAll('.stories__item');

//   if ((
//     (stories == null || storiesContainer == null) ||
//     (type == 'init' && storiesContainer != null && storiesContainer.classList.contains('init'))
//   )) {
//     return
//   }

//   if (window.innerWidth >= 768) {
//     stories.forEach((v, k) => v.style.transform = "translate3d(0, -" + ((window.scrollY / window.innerHeight) * parseInt(v.getAttribute('data-parallax'))) + "px, 0)");
//   } else {
//     stories.forEach((v, k) => v.style.transform = "none");
//   }

//   if (!storiesContainer.classList.contains('init')) {
//     storiesContainer.classList.add('init');
//   }
// }

export let storiesOverviewWidget = (r: Pair<CustomRouteParams<PublicSiteState, PublicSiteCustomRoutes>, CustomPagesState["Fc150YearsMainPage"]>): IOWidget<CustomPagesState['Fc150YearsMainPage'], Action<CustomPagesState['Fc150YearsMainPage']>> =>
  s0 => any<Action<CustomPagesState['Fc150YearsMainPage']>>()([

    fromJSX(setState => {
      setTimeout(() => {
        const el: HTMLElement = document.documentElement.querySelector('.main--themes');
        if (el != null && !el.classList.contains('inview')) {
          el.classList.add('inview');
        }
      }, 1000);

      themesRequestAnimationFrame();

      // When on About page
      if (s0.storiesOverviewState.isAbout) {
        let global_state: PublicSiteState = {
          ...emptyAppState(page),
          page: r.snd.state.page,
          Fc150YearsMainPage: s0
        }

        let template_props = {
          StandardBlockImagesLoader: WordPressBlockImagesLoader,
          StandardBlock_To_Widget: WordPressBlock_To_WidgetBlock,
          errorPage: notfound_page,
          loadingPage: loader,
          CustomBlock_To_Widget,
          CustomBlockImagesLoader: () => []
        }

        return PageTemplateComponent<Block, CustomBlock, CustomBlockData, ExtraImages, PublicSite_CustomPageData, PublicSiteState>({
          pageDisplay: p => global_state.page.pagedisplay(p, global_state),
          Display: b => global_state.page.display(b),
          CustomBlock_To_Widget: template_props.CustomBlock_To_Widget,
          CustomBLockImagesLoader: template_props.CustomBlockImagesLoader,
          StandardBlockImagesLoader: template_props.StandardBlockImagesLoader,
          StandardBlock_To_Widget: template_props.StandardBlock_To_Widget,
          errorPage: template_props.errorPage(global_state),
          loadingPage: template_props.loadingPage
        }, global_state)({
          blocks: global_state.page.blocks,
          images: global_state.page.images,
          custom_page_data: global_state.page.custom_page_data,
          page: global_state.page.page
        } as TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>).map<Action<PublicSiteState>>(a => s3 => {
          return { ...s3, page: { ...s3.page, ...a(s3.page) } };
        }).run(a => {
          setState(res1 => {
            let state1 = a({ ...global_state, page: res1.state.page })
            return { ...res1, state: state1 }
          })
        })
      }


      let taxonomy: WordPress.TaxonomyResponse = undefined
      if (s0.state.page.page.kind == 'loaded') {
        let page: any = s0.state.page.page.value as any
        taxonomy = page._embedded["wp:term"]?.length > 0 && page._embedded["wp:term"][0]?.length > 0 ? page._embedded["wp:term"][0][0] : undefined
      }

      if (taxonomy == undefined) return null

      // Temporary solution for taxonomy description, TODO: Add description to wordpress embeded response
      if (s0.taxonomiesLoader.kind == 'loaded' && taxonomy?.description == undefined) {
        taxonomy.description = s0.taxonomiesLoader.value.get(taxonomy?.id)?.description
      }

      // Just to make sure the stories overview always loads
      if (s0.storiesLoader.count() == 0) {
        setState(s3 => ({
          ...s3,
          storiesLoader: List([loadingAsyncState(() => get_stories_overview(r.fst.kind == 'Fc150YearsMainPage' ? r.fst.lang : 'en', taxonomy.id, 1))])
        }))
      }

      let stories = s0.storiesLoader.reduce((xs, x) => {
        if (x.kind == 'loaded') {
          return xs.concat(x.value.entity)
        }
        return xs
      },Array<WordPress.StoryResponse>())

      return (
        <main className={`main main--themes theme--${taxonomy?.slug}`}>
          <div className="main__inner">
            <header className="theme-intro">
              <div className="theme-intro__inner">
                <div className="theme-intro__content">
                  <div className="theme-intro__text grid--gutter">
                    <p className="theme-intro__label typo--3xl">{taxonomy?.name}</p>
                    <h1 className="theme-intro__title typo--4xl">{taxonomy?.description}</h1>

                    <img className="theme-intro__icon" width={taxonomy?.slug == 'heritage' ? '240' : taxonomy?.slug == 'sustainability' ? '172' : '160'} height="160" aria-hidden="true" alt=""
                      src={`/frontend/images/themes/icon--${taxonomy?.slug}.svg`}
                    />
                  </div>
                </div>
              </div>
            </header>

            <div className="theme-stories__wrap">
              {stories.length > 0 ? GroupArray(stories, 3).map((section, index) => {
                return <section className="theme-stories" key={`stories-${index}`}>
                  <div className="theme-stories__inner">
                    <div className="theme-stories__content">
                      <div className="stories">
                        {section.map(item => {
                          return <div key={item.id} className="stories__item" data-parallax={getRandomArbitrary(0, 250)}>
                            <NavLink to={`/${r.fst.kind == 'Fc150YearsMainPage' ? r.fst.lang : 'en'}/${s0.storiesOverviewState.title}/${item.slug}`} className="stories__link">
                              <div className="stories__content">
                                <h2 className="stories__title typo--m-to-l">{item.title.rendered}</h2>
                              </div>
                              <div className="portrait portrait--large portrait--theme">
                                <div className="portrait__inner">
                                  {item.featured_media_object && item.featured_media_object.source_url &&
                                    <div className="portrait__visual">
                                      <img className="portrait__image lazyload" width="400" height="400" alt=""
                                        src="/frontend/images/empty.png"
                                        data-src={getImageAttribute(item.featured_media_object, 'portrait_m', 'source_url')}
                                        data-srcset={`${getImageAttribute(item.featured_media_object, 'portrait_m', 'source_url')} 400w, ${getImageAttribute(item.featured_media_object, 'portrait_xl', 'source_url')} 800w`}
                                        data-sizes="auto"
                                      />
                                    </div>
                                  }
                                </div>
                              </div>
                            </NavLink>
                          </div>
                        })}
                      </div>
                    </div>
                  </div>
                </section>
              }) : loader.run(_ => { })}
            </div>

          </div>

          <div className="main__bg fit-object">
            <img className="main__bg-img" width="640w" height="360" alt="" aria-hidden="true"
              src={`/frontend/images/themes/bg--${taxonomy?.slug}-640w.jpg`}
              srcSet={`/frontend/images/themes/bg--${taxonomy?.slug}-640w.jpg 640w, /frontend/images/themes/bg--${taxonomy?.slug}-1280w.jpg 1280w, /frontend/images/themes/bg--${taxonomy?.slug}-1920w.jpg 1920w`}
              sizes="100vw"
            />
          </div>
        </main>
      )
    })
  ])
